import { ca } from '@cian/analytics';
import { offerHelper } from '../../presenter';
import { IOffer } from '../../types/offer';

/**
 * 3. Клик по карточке и переход на страницу самого предложения
 */
export const cardClickGoToOffer = (offer: IOffer) => {
  const product = offerHelper(offer).getAnalyticsInfo();

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card/slonotop',
    label: 'card_detail_in_newlist',
    products: [{ ...product, variant: product.variant ? product.variant.split('/') : undefined }],
  });
};

export const cardClickDescriptionMore = (offer: IOffer) => {
  const product = offerHelper(offer).getAnalyticsInfo();

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card/slonotop',
    label: 'card_more',
    products: [{ ...product, variant: product.variant ? product.variant.split('/') : undefined }],
  });
};

/**
 * 4. Переход в карточку объекта из листинга по клику на фото
 */
export const cardClickGalleryGoToOffer = (offer: IOffer) => {
  const product = offerHelper(offer).getAnalyticsInfo();

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card/slonotop',
    label: 'card_photo',
    products: [{ ...product, variant: product.variant ? product.variant.split('/') : undefined }],
  });
};

/**
 * 5. Клик по части адреса
 */
export const cardAddressBlockClick = (label: string = 'address') => {

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_address/slonotop',
    label,
  });
};

/**
 * 6. Переход в карточку объекта из листинга по клику на брендирование (полоска вверху)
 */
export const cardClickBrandingGoToOffer = (offer: IOffer) => {
  const product = offerHelper(offer).getAnalyticsInfo();

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card/slonotop',
    label: 'card_branding',
    products: [{ ...product, variant: product.variant ? product.variant.split('/') : undefined }],
  });
};

/**
 * Клик по названию в карточке
 */
export const titleClick = (offer: IOffer) => {
  const product = offerHelper(offer).getAnalyticsInfo();

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card/slonotop',
    label: 'card_header_in_newlist',
    products: [{ ...product, variant: product.variant ? product.variant.split('/') : undefined }],
  });
};

export const toFromFavorite = (offer: IOffer, action: 'add' | 'remove') => {
  ca('event', {
    name: 'oldevent',
    category: 'favorite',
    action: `${action}/slonotop`,
    label: offer.gaLabel,
  });
};
